import * as yup from 'yup';

export const getPasscodeSchema = (): yup.StringSchema => yup.string().max(512);
